import type { ExternalTableSchema } from '@packages/table-builder';

export const transferAndAllocateTable: ExternalTableSchema = {
  metadata: {
    title: 'Transfer and Allocate',
    entity: 'TransferAndAllocate',
    description: 'View all transfer and allocate containers.',
  },

  dataSource: {
    endpoint: '/api/award/api/app/transfer-allocate/transfer-allocate-list',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      SearchKeyWord: 'table.searchText',
      Filter: '',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
      ContainerStatusIds: 'filters.approvalStatusId',
    },
    filters: [
      {
        name: 'approvalStatusId',
        placeholder: 'Container Status',
        type: 'asyncSelect',
        multiple: true,
        dataSource: {
          url: '/api/award/api/app/transfer-allocate/container-statuses',
          labelField: 'displayName',
          valueField: 'id',
        },
      },
    ],
  },

  columns: [
    {
      field: 'name',
      header: 'Name',
      sortable: true,
      width: 200,
      visibility: 'locked',
    },
    {
      field: 'transferStatus',
      header: 'Status',
      type: 'badge',
      sortable: true,
      width: 250,
      align: 'center',
      badge: {
        statusMap: {
          'Ready To Execute': 'primary',
          Allocated: 'success',
          'Pending broker': 'info',
          Failed: 'error',
          Draft: 'info',
        },
        defaultVariant: 'info',
      },
    },
    {
      field: 'items',
      header: '#Items',
      type: 'text',
      sortable: true,
      width: 200,
      emptyDisplay: '-',
    },
    {
      field: 'noOfShares',
      header: '#Shares',
      type: 'text',
      sortable: true,
      width: 200,
      emptyDisplay: '-',
    },
    {
      field: 'creationTime',
      header: 'Created Date',
      type: 'date',
      sortable: true,
      width: 200,
      align: 'center',
      visibility: 'picker',
      emptyDisplay: '-',
    },
  ],

  actions: {
    row: [
      { id: 'VIEW_TRANSFER_ALLOCATE', label: 'Summary' },
      { id: 'EDIT_TRANSFER_ALLOCATE', label: 'Edit' },
      { id: 'CHECK_TRANSFER_STATUS_TRANSFER_ALLOCATE', label: 'Check Transfer Status' },
      { id: 'RETRY_TRANSFER_ALLOCATE', label: 'Retry' },
      { id: 'RENAME_TRANSFER_ALLOCATE', label: 'Rename' },
      { id: 'DELETE_TRANSFER_ALLOCATE', label: 'Delete', variant: 'danger' },
    ],
    toolbar: {
      primary: {
        id: 'CREATE_TRANSFER_ALLOCATE',
        label: 'Create Transfer And Allocate',
        icon: 'add_circle_outline',
      },
    },
  },

  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    columnPreferences: {
      persistenceKey: 'Transfer and Allocate',
      resizable: true,
      reorderable: true,
    },
  },
};
